import { createFileRoute } from '@tanstack/react-router';

import { crownQueryClient } from '@/common/api/crownQueryClient';
import { listOmnibusAccountsQuery } from '@/features/administrator-panel/omnibus/api/omnibusAccountApi';
import { OMNIBUS_ACCOUNTS_PER_PAGE } from '@/features/administrator-panel/omnibus/OmnibusAccountsGrid.tsx';
import { OmnibusAccounts } from '@/features/administrator-panel/omnibus/OmnibusAccounts.tsx';

export const Route = createFileRoute('/admin/configuration/omnibus/')({
  loader: () =>
    crownQueryClient.fetchInfiniteQuery(
      listOmnibusAccountsQuery({ perPage: OMNIBUS_ACCOUNTS_PER_PAGE }),
    ),
  component: OmnibusAccounts,
});
